/**
 *
 * @param str {string}
 * @returns {string}
 */
export const changeWordToTitle = (str) => {
  return str.replace(/(\([^()]*\))|(\S)(\S*)/g, (_, group1, group2, group3) => group1 || group2.toUpperCase() + group3.toLowerCase());
}
